'use client';

import { useEffect, useState } from 'react';

import { Footer } from '@/src/components/Footer';
import { Header } from '@/src/components/Header/Header';

const BlogsLayout = ({ children }: any) => {
  const [displayShadow, setDisplayShadow] = useState(false);
  const handleScroll = () => {
    setDisplayShadow(window.scrollY > 250);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      <Header displayShadow={displayShadow} ribbonVisible={false} />
      {children}
      <Footer />
    </>
  );
};

export default BlogsLayout;
